/**
 * return the input value
 * @param x
 */
const identity = x=>x;
export default identity;



// WEBPACK FOOTER //
// ./src/identity.ts